import { Component } from '@angular/core';
import { Events, ModalController, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';

import { LaunchReview } from '@ionic-native/launch-review';

import { TabsPage } from '../pages/tabs/tabs';
import { CodePush, InstallMode } from '@ionic-native/code-push';
import { KioskServiceProvider } from '../providers/kiosk-service/kiosk-service';
import { AppLoadingPage } from '../pages/app-loading/app-loading';
import { WpProvider } from '../providers/wp/wp';
import { WelcomeMessageComponent } from '../components/welcome-message/welcome-message';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = AppLoadingPage;
  idleTimeout = null;

  offline = false;
  welcomeStarted = false;

  constructor(private platform: Platform,
              statusBar: StatusBar,
              private codePush: CodePush,
              splashScreen: SplashScreen,
              private launchReview: LaunchReview,
              private storage: Storage,
              private kioskService: KioskServiceProvider,
              private wp: WpProvider,
              private modal: ModalController) {

    this.wp.appReady.subscribe(ready => {
      if (ready) {
        this.rootPage = TabsPage;
      } else {
        this.rootPage = AppLoadingPage;
      }

      if (!this.kioskService.isKiosk && this.wp.app.home_headline && this.wp.app.home_welcome_msg && !this.welcomeStarted) {
        this.welcomeStarted = true;
        setTimeout(() => {
          this.openWelcomeMsg();
        }, 1500);

        setInterval(() => {
          this.openWelcomeMsg();
        }, 1000 * 60 * 30);
      }
    });

    setInterval(() => {
      this.offline = !navigator.onLine;
    }, 2500);

    this.resetIdleTimeout();
    this.kioskService.appActivity.subscribe(() => {
      this.resetIdleTimeout();
    });

    platform.ready().then(() => {

      // PUSH SETUP
      // TODO switch to live api key before store release

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.hide();
      splashScreen.hide();

      if (platform.is('cordova')) {
        (<any>window.screen).orientation.lock('portrait');
        if (platform.is('ios')) {
          console.log(platform.is('ios'));

          console.log('KEY IS', window['PUSH_IOS']);
          window['plugins'].PushbotsPlugin.initialize(window['PUSH_IOS']);

          window['plugins'].PushbotsPlugin.on("registered", function(token){
            console.log("Registration Id:" + token);
          });

          window['plugins'].PushbotsPlugin.on("user:ids", function(data){
            console.log("user:ids" + JSON.stringify(data));
          });
        }
      }


      storage.get('lastReview').then((val) => {
        if(!val){
          storage.set('lastReview', Date.now());
          setTimeout(() => {
            this.openReview();
          }, 120000 * 2);
        }else{
          const now = Date.now();
          if(now > (val + (1000 * 60 * 60 * 24 * 3))){
            storage.set('lastReview', Date.now());
            this.openReview();
          }
        }
      });

    });
  }

  public resetIdleTimeout() {
    clearTimeout(this.idleTimeout);
  }

  private openReview() {
    if(this.launchReview.isRatingSupported()){
      this.launchReview.rating()
        .then(() => console.log('Successfully launched rating dialog'));
    }else{
      this.launchReview.launch()
        .then(() => console.log('Successfully launched store app'));
    }
  }

  private openWelcomeMsg() {
    console.log('opening modal');
    const modal = this.modal.create(WelcomeMessageComponent, {}, {
      cssClass: 'large-modal',
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts